package one.healthium.ui.effect

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.lifecycle.compose.LifecycleResumeEffect
import kotlinx.coroutines.delay
import kotlinx.coroutines.isActive
import kotlinx.coroutines.launch
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime
import loco.GENERAL_GOOD_AFTERNOON
import loco.GENERAL_GOOD_EVENING
import loco.GENERAL_GOOD_MORNING
import org.jetbrains.compose.resources.stringResource
import kotlin.time.Clock
import kotlin.time.Duration.Companion.minutes

@Composable
fun greetingMessage(addEmoji: Boolean = false): String {
    var now by remember { mutableStateOf(Clock.System.now().toLocalDateTime(TimeZone.currentSystemDefault())) }

    val scope = rememberCoroutineScope()

    LifecycleResumeEffect(Unit) {
        val job = scope.launch {
            while (isActive) {
                now = Clock.System.now().toLocalDateTime(TimeZone.currentSystemDefault())
                delay(1.minutes.inWholeMilliseconds)
            }
        }
        onPauseOrDispose {
            job.cancel()
        }
    }

    val (message, emoji) = when (now.hour) {
        in 5..11 -> stringResource(loco.Res.string.GENERAL_GOOD_MORNING) to "☀️"
        in 12..17 -> stringResource(loco.Res.string.GENERAL_GOOD_AFTERNOON) to "☀️"
        in 18..21 -> stringResource(loco.Res.string.GENERAL_GOOD_EVENING) to "🌙"
        else -> stringResource(loco.Res.string.GENERAL_GOOD_EVENING) to "🌙"
    }

    if (addEmoji) {
        return "$message $emoji"
    }

    return message
}
